export function formatDateShort(dateString: string | undefined): string {
	if (!dateString) {
		return "";
	}

	if (dateString === "-") {
		return "-";
	}

	const trimmed = dateString.trim();
	const hasTimePart = trimmed.includes("T");
	const parsedInput = hasTimePart ? trimmed : `${trimmed}T00:00:00`;
	const date = new Date(parsedInput);
	if (Number.isNaN(date.getTime())) {
		return dateString;
	}

	const dd = String(date.getDate()).padStart(2, "0");
	const mm = String(date.getMonth() + 1).padStart(2, "0");
	const yyyy = String(date.getFullYear());
	return `${dd}/${mm}/${yyyy}`;
}

export function formatCompactDateTime(dateString: string | undefined): string {
	const raw = String(dateString ?? "").trim();
	if (!raw || raw === "-") {
		return "-";
	}

	const parsedInput = raw.includes("T") ? raw : `${raw}T00:00:00`;
	const date = new Date(parsedInput);
	if (Number.isNaN(date.getTime())) {
		return raw;
	}

	const yy = String(date.getFullYear()).slice(-2);
	const mm = String(date.getMonth() + 1).padStart(2, "0");
	const dd = String(date.getDate()).padStart(2, "0");
	const hh = String(date.getHours()).padStart(2, "0");
	const min = String(date.getMinutes()).padStart(2, "0");

	return `${yy}${mm}${dd} ${hh}:${min}`;
}

export function formatCompactDate(dateString: string | undefined): string {
	const raw = String(dateString ?? "").trim();
	if (!raw || raw === "-") {
		return "-";
	}

	const parsedInput = raw.includes("T") ? raw : `${raw}T00:00:00`;
	const date = new Date(parsedInput);
	if (Number.isNaN(date.getTime())) {
		return raw;
	}

	const yy = String(date.getFullYear()).slice(-2);
	const mm = String(date.getMonth() + 1).padStart(2, "0");
	const dd = String(date.getDate()).padStart(2, "0");


	return `${yy}${mm}${dd}`;
}

export function formatCompact2DateTime(dateString: string | undefined): string {
    const raw = String(dateString ?? "").trim();
    if (!raw || raw === "-") {
        return "-";
    }

    const parsedInput = raw.includes("T") ? raw : `${raw}T00:00:00`;
    const date = new Date(parsedInput);
    if (Number.isNaN(date.getTime())) {
        return raw;
    }

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");

    return `${dd}/${mm}/${yyyy} ${hh}:${min} น.`;
}